module.exports = __webpack_public_path__ + "static/img/li7_1.22d8ccda.png";